<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>角色流程管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;">
          <el-tree :data="dataTree" ref="tree" :props="defaultProps" default-expand-all :expand-on-click-node="false"
            :highlight-current="true" @node-click="handleNodeClick" node-key="processType"
            :current-node-key="currentNodekey" :default-expanded-keys="expandedkeys"></el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;">
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <div style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px;">

            <div style="display:flex;align-items: center;width:20%;justify-content: space-between">
              <el-button type="primary" @click="add">添加</el-button>
              <!-- </div> -->
            </div>

          </div>
          <div class="build-table">
            <el-table :data="listData" height="100%" border style="width: 100%;" stripe
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index+1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="单位名称">
                <template slot-scope="scope">
                  <span>{{ find(scope.row.proProjectEntId) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="流程状态" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.processStatus }}</span>
                </template>
              </el-table-column>
              <el-table-column label="流程排序" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.processSort }}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建人" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.createBy }}</span>
                </template>
              </el-table-column>
              <el-table-column label="创建时间" width="160" prop="salaryMonth" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button size="mini" @click="edit(scope.row)">修改</el-button>
                  <el-button size="mini" @click="deleteList(scope.row)" type="danger">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--添加-->
            <el-dialog :title="diaTitle" :visible.sync="editFormVisible" center :append-to-body="true"
              :lock-scroll="false" width="30%">
              <el-form :model="form" ref="editForm" label-width="35%" label-position="left" class="teamPage"
                :rules="teamRules">
                <el-form-item label="单位列表" prop="roleId">
                  <el-select v-model="form.proProjectEntId" placeholder="请选择">
                    <el-option v-for="item in unitType" :key="item.id" :label="item.label" :value="item.projectEntId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="流程状态" prop="processStatus">
                  <el-input v-model="form.processStatus" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="流程排序" prop="processStatus">
                  <el-input v-model="form.processSort" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('editForm')">确 定</el-button>
              </div>
            </el-dialog>

          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      var checkPrice = (rule, value, callback) => {
        // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
        if (value == '') {
          callback(new Error('请输入单价'))
        } else if (!this.isCellPrice(value)) {
          //引入methods中封装的检查手机格式的方法
          callback(new Error('请输入正确的格式!'))
        } else {
          callback()
        }
      }
      return {
        dataTree: [
          { name: '物料审批流程管理', processType: 'cc_sp' },
        ],
        listData: [],
        search: {
          //查询
          companyId: '',
          processType: ''
        },
        classId: '', //班组id
        // currentPage: 1,
        // pageSize: 10,
        // totalItems: 0,
        dataText: '数据加载中...',
        uploadUrl: base.url + '/inoutApply/uploadInoutApply',
        uploadHead: {
          accessToken: this.$store.state.token,
        },
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        currentNodekey: '', //默认选中的节点树
        expandedkeys: [], //默认展开的节点树
        dialogTitle1: '导入结果',
        imoportVisible: false,
        tableData1: [],
        editFormVisible: false,
        diaTitle: '',
        form: {
          projectId: util.session.get('groupId'),
          proProjectEntId: '',
          processStatus: '',
          processSort: '',
          processType: 'cc_sp',
          processId: ''
        },
        unitType: [],
        teamRules: {
          materialCoding: [
            {
              required: true,
              message: '请输入产品编号,无产品编号,可选生成编号',
              trigger: 'blur',
            },
          ],
          supplier: [
            { required: true, message: '请输入供应商', trigger: 'blur' },
          ],
          materialName: [
            { required: true, message: '请输入材料名称', trigger: 'blur' },
          ],
          specifications: [
            { required: true, message: '规格型号', trigger: 'blur' },
          ],
          measuringUnit: [
            { required: true, message: '请选择计量单位', trigger: 'blur' },
          ],
          // unitPrice: [{ required: true, validator: checkPrice, trigger: 'blur' }], //validator: checkphone是验证手机的引入checkphone函数
          // number: [{ required: true, validator: checkPrice, trigger: 'blur' }],
        },
        //二维码
        codeVis: false,
        codeUrl: '',
        codeTit: '',
        uploadUrl1: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead1: {
          accessToken: util.session.get('token'),
        },
        icon: '',//材料图片
        invoice: '',//发票图片
        http: base.httpCtx,
        nameCode: '产品编码',
        nameMat: '材料名称',
        editFormVisible1: false,
        //备注
        remarkVis: false,
        remarkForm: {
          id: '',
          remarks: ''
        },
        remarksTitle: '',//
      }
    },
    created() {
      // if (util.session.get('roleId') == '4') {
      this.search.companyId = util.session.get('companyId')

      // } else {
      //   this.search.companyId = util.session.get('proId')
      // }
    },
    mounted() {

      if (this.dataTree.length > 0) {
        this.search.processType = this.dataTree[0].processType
        this.currentNodekey = this.dataTree[0].processType
        this.expandedkeys.push(this.dataTree[0].processType)
        this.$nextTick(() => {
          // treeBox 元素的ref   value 绑定的node-key
          this.$refs.tree.setCurrentKey(this.currentNodekey)
        })
      }
      this.getData()
      this.getJoinEnt()
      // this.getMate()
    },
    methods: {
      // 搜索数据
      doFilter(index) {
        // this.search.startDate = this.date ? this.date[0] : ''
        // this.search.endDate = this.date ? this.date[1] : ''
        this.search.personStatus = index
        this.getData()
      },
      // 获取数据
      getData() {
        var that = this
        myHttp.findProProcessList({
          processType: 'cc_sp',
          porjectId: util.session.get('groupId')
        }).then(
          function (resp) {
            console.log(resp)
            if (resp.data.code == '200') {
              that.listData = resp.data.data
              if (that.listData.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () {
            that.dataText = '服务器繁忙中，请稍后请求'
          }
        )
      },
      find(proProjectEntId){
        console.log(this.unitType);
        console.log(proProjectEntId);
        let name = ''
        this.unitType.forEach(item => {
          if(item.projectEntId == proProjectEntId){
             name =item.label
          }
        })
        return name
      },
      //获取参建单位
      getJoinEnt() {
        var that = this
        myHttp.getProjectEntByProjectId({
          projectId: util.session.get('groupId')
        }).then(function (resp) {
          console.log(resp);
          if (resp.data.code == '200') {
            that.unitType = resp.data.data.projectEnt || []

          } else {

          }
        })
      },
      //删除
    deleteList(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteRoleProcess({
              processId: row.processId,
            })
            .then((resp) => {
              console.log(resp)
              if (resp.data.code == '200') {
                this.$message.success('删除成功')
                this.getData()
              } else {
                this.$message.error(resp.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
      //获取字典表
      zidian() {
        var that = this
        myHttp
          .getDictByType({
            type: 'user_type',
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.dictList || []
            }
          })
      },
      // weight_type
      // 获取计量单位
      getUnit() {
        // var that = this
        // myHttp
        //   .companyRoleList({
        //     groupId:this.search.companyId
        //   })
        //   .then(function (resp) {
        //     if (resp.data.code == '200') {
        //       console.log(resp)
        //       var list = resp.data.data || []
        //       that.unitType = list
        //     }
        //   })
      },
      //
      // handleSizeChange(val) {
      //   this.pageSize = val
      //   this.handleCurrentChange(this.currentPage)
      // },
      // handleCurrentChange(val) {
      //   this.currentPage = val
      //   this.currentChangePage()
      // },
      // 监控当前页码
      // currentChangePage(list) {
      //   this.getData()
      // }

      //点击树形结构
      handleNodeClick(data) {
        console.log(data)
        this.search.processType = data.processType
        this.editForm.processType = data.processType
        this.nameCode = this.editForm.processType != '4' ? '产品编码' : '构件编码'
        this.nameMat = this.editForm.processType != '4' ? '材料名称' : '构件名称'
        this.getData()
        console.log(this.editForm.processType)
      },

      watchInput(e) {
        // console.log(e)
        this.search.personStatus = e
        this.getData()
      },
      /**添加材料 */
      add() {
        console.log(12111);
        this.diaTitle = '添加'
        this.form.proProjectEntId = ''
        this.form.processStatus = ''
        this.form.processSort = ''
        this.form.processId = ''
        this.editFormVisible = true
      },
      // 修改发票信息
      edit(row) {
        this.diaTitle = '修改'
        this.form.proProjectEntId = row.proProjectEntId
        this.form.processStatus = row.processStatus
        this.form.processSort = row.processSort
        this.form.processId = row.processId
        this.editFormVisible = true
      },

      sumbitAddRow(formName) {
        var that = this
            if (this.form.processId == '') {
              myHttp.addRoleProcess(this.form).then(function (resp) {
                console.log(resp);
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.editFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            } else {
              myHttp.editProProcess(this.form).then(function (resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.editFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              })
            }
      },
    },
  }
</script>
<style>
  /**
*图片放大右上角关闭按钮
*/
  .el-image-viewer__close i {
    font-size: 4vh;
    color: #fff;
  }

  /* @import '../../assets/css/common.css'; */
</style>
<style scoped>
  /* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
  .grid-content {
    height: 2.5vh;
    font-size: 1.6vh;
  }

  .aside {
    box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
    border-radius: 10px !important;
    border: 0px !important;
    background-color: rgb(255, 255, 255);
  }

  .grid-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 40%;
  }

  .content>>>.el-card__body {
    padding: 0 !important;
    height: 100% !important;
  }

  .build-table {
    height: calc(100% - 80px);
  }

  .active {
    background: #409eff;
    color: #fff;
  }

  .contract-con {
    width: 100%;
    background: #fff;
    height: 125px;
    font-size: 14px;
  }

  .contract-con p {
    width: 100%;
    padding: 2px 20px;
    text-align: left;
  }

  .content>>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    color: #4d95fd;
    font-weight: bold;
    padding: 10px 0px;
  }

  /* .el-dialog__body>>>.el-form-item>.el-form-item__content>.el-input-group--append .el-input__inner{
  width: 200px !important;
} */
  .content>>>.el-tree {
    padding: 30px;
  }

  .content>>>.el-input>.el-input__inner {
    width: 188px;
  }

  .erCode {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .avatar {
    width: 100%;
  }

  .el-dialog .el-input {
    max-width: 220px;
  }
</style>